/** Sentence-case label for each submission stage, in the order the stages run. */
export const STAGE_LABELS: Readonly<Record<string, string>> = {
  DOCUMENTS: 'Documents',
  EXTRACTION: 'Extraction',
  BUSINESS_DETAILS: 'Business details',
  CONTACTS: 'Contacts',
  PRODUCTS: 'Products',
  QUOTE_OPTIONS: 'Quote options',
  QUOTING: 'Quoting',
};

/** Label for the state of the current stage. DONE and SKIPPED never reach the list. */
export const STAGE_STATE_LABELS: Readonly<Record<string, string>> = {
  NOT_STARTED: 'not started',
  IN_PROGRESS: 'in progress',
  NEEDS_INPUT: 'needs input',
};

const sentenceCase = (value: string): string => {
  const spaced = value.toLowerCase().replace(/_/g, ' ');
  return spaced.charAt(0).toUpperCase() + spaced.slice(1);
};

/** For example "Business details: needs input". Blank when the submission has no current stage. */
export const stageLabel = (
  stage: string | null | undefined,
  state: string | null | undefined
): string => {
  if (!stage) {
    return '';
  }
  const stageText = STAGE_LABELS[stage] ?? sentenceCase(stage);
  if (!state) {
    return stageText;
  }
  const stateText =
    STAGE_STATE_LABELS[state] ?? state.toLowerCase().replace(/_/g, ' ');
  return `${stageText}: ${stateText}`;
};

/** The Stage column belongs to the Portal tab and the All tab (no pinned source). */
// A string compare: this util stays free of the listing's SUBMISSION_SOURCE enum import.
export const stageColumnShownForSource = (
  submissionSource: string | undefined
): boolean => !submissionSource || submissionSource === 'BROKER_PORTAL';
